import { Component, inject, OnInit, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AppConfig } from '../appconfig';
import { LfwRouterService } from '../route/lfw-router.service';
import { ToolbarPosition } from '../shared/enums/toolbar-position';
import { SettingsService } from '../shared/settings/settings.service';
import { BottomNavigationComponent, SidebarNavigationComponent, TopbarNavigationComponent } from './navigation';
import { UserInformationService } from './user-information.service';

@Component({
  selector: 'lfw-main-navigation',
  templateUrl: './main-navigation.component.html',
  imports: [RouterOutlet, TopbarNavigationComponent, SidebarNavigationComponent, BottomNavigationComponent]
})
export class MainNavigationComponent implements OnInit {
  protected readonly ToolbarPosition = ToolbarPosition;
  protected readonly loaded = signal(false);

  private readonly translate = inject(TranslateService);
  private readonly routerService = inject(LfwRouterService);
  private readonly settingsService = inject(SettingsService);
  private readonly config = inject(AppConfig);
  private readonly userService = inject(UserInformationService);

  protected readonly toolbarPosition = toSignal(
    this.settingsService.settings.viewMode.modeChange.pipe(
      startWith(null),
      map(() => this.settingsService.settings.viewMode.toolbarPosition)
    ),
    { initialValue: this.settingsService.settings.viewMode.toolbarPosition }
  );

  constructor() {
    this.settingsService.settings.themes.setSelectedTheme(1);
    this.translate.setFallbackLang('en');
    this.translate.use('en');
  }

  ngOnInit(): void {
    if (this.config.hasError()) {
      this.routerService.errorStop('CONFIGERROR');
      return;
    }
    forkJoin([this.settingsService.getSettings(), this.userService.getUser()]).subscribe(() => {
      this.loaded.set(true);
    });
  }
}
